import { View, StyleSheet } from 'react-native';
import { Text, theme } from '@socrait/react';

import { SessionStatus } from '~/services/types';

export type ProcessingBannerProps = {
  status: SessionStatus;
};

export const ProcessingBanner = ({ status }: ProcessingBannerProps) => {
  let text: string;
  switch (status) {
    case 'IN_PROGRESS':
      text = 'Your session is in progress. Data may not be complete.';
      break;
    case 'PROCESSING':
      text = 'Your session is processing. Please wait 30 seconds and then refresh the screen.';
      break;
    default:
      // The banner should only be shown for pending session statuses.
      console.error('Invalid session status', status);
      text = '';
      break;
  }
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: theme.colors.primaryPurple,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing.large,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1,
  },
  text: {
    color: theme.colors.white,
    fontSize: theme.fontSizes.small,
  },
});
